<template>
  <CommonDrop
      v-model="currentValue"
      :url="dataUrl"
      :autoDefault="false"
      :filterable="true"
      :remote="true"
      valName="id"
      labelName="label"
      :disabled="false"
      :clearable="true"
      size="mini"
      placeholder="请选择预付款"
      :before-binding="beforeBinding"
      :is-page-url="true"
  ></CommonDrop>
</template>

<script>
import CommonDrop from '@/components/CommonDrop/index.vue'

export default {
  name: 'per-pay-drop',
  components: { CommonDrop },
  props: {
    value: {
      type: String,
      default: '',
    },
    companyId: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataUrl () {
      if (!this.companyId ) {
        return ''
      }
      return `/erp/per/pay/page?page=1&limit=100000&companyId=${this.companyId}&orderId=${this.orderId}`
    },
    currentValue: {
      get () {
        if (this.value === null || this.value === undefined) {
          return ''
        }
        return String(this.value)
      },
      set (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      },
    },
  },
  methods: {
    beforeBinding (dataList) {
      dataList.forEach(item => {
        item.label = ` ${this.$c.companyName(item.receiverName)}【${item.orderCode}：¥${item.limitAmount}】`
      })
    }
  }
}
</script>

<style scoped>

</style>
